import { memo, useCallback, useContext, useEffect, useState } from "react";
import MaskService from "../../../../../../utils/mask/maskService";
import { EmissaoContext } from "../../../contexts/EmissaoContext";
import { QueryParamsContext } from "../../../../../../context/QueryParamsContext";
import GFDataTable from "../../../../../../components/tables/GFDataTable";
import { getProductTaxNote } from "../../../../../../repositories/qerpapi/v3/empresa/notafiscal";
import { Grid, TextField, Tooltip } from "@material-ui/core";
import { notify } from "../../../../../../utils/notify";
import { BrushSharp, Info } from "@material-ui/icons";
import Btn from "../../../../../../components/buttons/Btn";

let typingTimer = null;
const orderFields = "dataemissao,numero";
const orderType = "desc";

const PurchaseTaxNoteTable = () => {
  const { queryParams } = useContext(QueryParamsContext);
  const {
    selectedSupplier,
    selectedPurchaseNf,
    setSelectedPurchaseNf,
    purchaseStartDate,
    setPurchaseStartDate,
    purchaseFinalDate,
    setPurchaseFinalDate,
    setSelectedPurchaseItems,
  } = useContext(EmissaoContext);

  const [firstSearch, setFirstSearch] = useState(true);
  const [textFilter, setTextFilter] = useState("");
  const [filterParams, setFilterParams] = useState({
    companyId: queryParams.empresa_id,
    filters: {
      idempresa: `strict:${queryParams.empresa_id}`,
      idclifor: `strict:${selectedSupplier[0].id}`,
      indicadoremitente: `strict:T`,
      clifor: `strict:F`,
      status: `different:C`,
      ...(purchaseStartDate && purchaseFinalDate
        ? { dataemissao: `between:${purchaseStartDate},${purchaseFinalDate}` }
        : {}),
    },
    orderFields: orderFields,
    orderType: orderType,
  });

  const columnsTaxNoteSearch = [
    {
      label: "Nr. NF compra",
      id: "numero",
      align: "center",
    },
    {
      label: "Total",
      id: "vl_nf",
      align: "center",
      format: (value) =>
        value?.vl_nf
          ? Number(value.vl_nf).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          : "-",
    },
    {
      label: "Data da Compra",
      id: "dataemissao",
      align: "center",
      format: (value) =>
        value?.dataemissao ? MaskService.dateYmdToDmy(value.dataemissao) : "-",
    },
  ];

  const clearDate = useCallback(() => {
    setPurchaseStartDate("");
    setPurchaseFinalDate("");
  }, [setPurchaseFinalDate, setPurchaseStartDate]);

  const handleSearchTaxNote = useCallback(() => {
    const hasOneDate =
      !!(purchaseStartDate && !purchaseFinalDate) ||
      !!(!purchaseStartDate && purchaseFinalDate);

    if (hasOneDate)
      return notify("Utilize ambas as datas ou nenhuma!", true, "warning");

    setFilterParams({
      companyId: queryParams.empresa_id,
      filters: {
        idempresa: `strict:${queryParams.empresa_id}`,
        idclifor: `strict:${selectedSupplier[0].id}`,
        indicadoremitente: `strict:T`,
        clifor: `strict:F`,
        status: `different:C`,
        ...(purchaseStartDate && purchaseFinalDate
          ? { dataemissao: `between:${purchaseStartDate},${purchaseFinalDate}` }
          : {}),
        ...(textFilter ? { numero: `like:${textFilter}` } : {}),
      },
      orderFields: orderFields,
      orderType: orderType,
    });
    // eslint-disable-next-line
  }, [purchaseFinalDate, purchaseStartDate, textFilter]);

  useEffect(() => {
    if (firstSearch) return setFirstSearch(false);
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      handleSearchTaxNote();
    }, 2000);
    // eslint-disable-next-line
  }, [handleSearchTaxNote]);

  useEffect(() => {
    setSelectedPurchaseNf([]);
    setSelectedPurchaseItems([]);
  }, [setSelectedPurchaseItems, setSelectedPurchaseNf]);

  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item xs={6}>
        <TextField
          label="Busque Pelo Nr. NF compra"
          value={textFilter}
          onChange={({ target: { value } }) => {
            setTextFilter(value.replace(/[^0-9]+/g, ""));
          }}
          variant="filled"
          fullWidth
        />
      </Grid>

      <Grid item xs={2}>
        <TextField
          label="Data Inicial"
          type="date"
          size="small"
          fullWidth
          focused
          value={purchaseStartDate}
          onChange={({ target: { value } }) => {
            setPurchaseStartDate(value);
          }}
        />
      </Grid>

      <Grid
        item
        md={1}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Btn
          bgcolor={"whitesmoke"}
          startIcon={<BrushSharp style={{ color: "black" }} />}
          style={{ width: "40px" }}
          onClick={clearDate}
        />
      </Grid>

      <Grid item xs={2}>
        <TextField
          label="Data Final"
          type="date"
          size="small"
          fullWidth
          focused
          value={purchaseFinalDate}
          onChange={({ target: { value } }) => {
            setPurchaseFinalDate(value);
          }}
        />
      </Grid>
      <Grid item xs={1}>
        <Tooltip title="Utilize ambas as datas ou nenhuma.">
          <Info />
        </Tooltip>
      </Grid>

      <Grid item xs={12}>
        <GFDataTable
          stickyHeader
          fnQuery={getProductTaxNote}
          fnFiltersParams={filterParams}
          columns={columnsTaxNoteSearch}
          selectable={true}
          selected={selectedPurchaseNf}
          setSelected={setSelectedPurchaseNf}
        />
      </Grid>
    </Grid>
  );
};

export default memo(PurchaseTaxNoteTable);
